import CAProvinces from 'provinces-ca'
import { UsaStates } from 'usa-states'

import type { State } from './types'

export const REASONS_MAP: Record<string, string> = {
  high_cost: 'The cost was too high',
  no_activity: 'It wasn’t as active as I was hoping for',
  disliked_perks: 'I didn’t like the perks that I received',
  hard_to_find_perks: 'It was too hard to find or access my perks',
  joined_for_specific_post_or_perk: 'I only joined for a specific post or perk',
}

export const US_STATES: State[] = new UsaStates({
  includeTerritories: true,
  exclude: ['PW', 'MH', 'FM'],
  ignoreCharacter: '$',
  contiguousOnly: false,
}).states.map(({ name, abbreviation }) => ({
  name,
  abbreviation,
}))

export const MILITARY_US_STATES: State[] = [
  { name: 'Armed Forces America', abbreviation: 'AA' },
  { name: 'Armed Forces Europe', abbreviation: 'AE' },
  { name: 'Armed Forces Pacific', abbreviation: 'AP' },
]

export const CA_STATES: State[] = CAProvinces.map(({ name, abbreviation }) => ({
  name,
  abbreviation,
}))

export const JP_STATES: State[] = [
  { name: 'Aichi', abbreviation: 'Aichi' },
  { name: 'Akita', abbreviation: 'Akita' },
  { name: 'Aomori', abbreviation: 'Aomori' },
  { name: 'Chiba', abbreviation: 'Chiba' },
  { name: 'Ehime', abbreviation: 'Ehime' },
  { name: 'Fukui', abbreviation: 'Fukui' },
  { name: 'Fukuoka', abbreviation: 'Fukuoka' },
  { name: 'Fukushima', abbreviation: 'Fukushima' },
  { name: 'Gifu', abbreviation: 'Gifu' },
  { name: 'Gunma', abbreviation: 'Gunma' },
  { name: 'Hiroshima', abbreviation: 'Hiroshima' },
  { name: 'Hokkaido', abbreviation: 'Hokkaido' },
  { name: 'Hyogo', abbreviation: 'Hyogo' },
  { name: 'Ibaraki', abbreviation: 'Ibaraki' },
  { name: 'Ishikawa', abbreviation: 'Ishikawa' },
  { name: 'Iwate', abbreviation: 'Iwate' },
  { name: 'Kagawa', abbreviation: 'Kagawa' },
  { name: 'Kagoshima', abbreviation: 'Kagoshima' },
  { name: 'Kanagawa', abbreviation: 'Kanagawa' },
  { name: 'Kochi', abbreviation: 'Kochi' },
  { name: 'Kumamoto', abbreviation: 'Kumamoto' },
  { name: 'Kyoto', abbreviation: 'Kyoto' },
  { name: 'Mie', abbreviation: 'Mie' },
  { name: 'Miyagi', abbreviation: 'Miyagi' },
  { name: 'Miyazaki', abbreviation: 'Miyazaki' },
  { name: 'Nagano', abbreviation: 'Nagano' },
  { name: 'Nagasaki', abbreviation: 'Nagasaki' },
  { name: 'Nara', abbreviation: 'Nara' },
  { name: 'Niigata', abbreviation: 'Niigata' },
  { name: 'Oita', abbreviation: 'Oita' },
  { name: 'Okayama', abbreviation: 'Okayama' },
  { name: 'Okinawa', abbreviation: 'Okinawa' },
  { name: 'Osaka', abbreviation: 'Osaka' },
  { name: 'Saga', abbreviation: 'Saga' },
  { name: 'Saitama', abbreviation: 'Saitama' },
  { name: 'Shiga', abbreviation: 'Shiga' },
  { name: 'Shimane', abbreviation: 'Shimane' },
  { name: 'Shizuoka', abbreviation: 'Shizuoka' },
  { name: 'Tochigi', abbreviation: 'Tochigi' },
  { name: 'Tokushima', abbreviation: 'Tokushima' },
  { name: 'Tokyo', abbreviation: 'Tokyo' },
  { name: 'Tottori', abbreviation: 'Tottori' },
  { name: 'Toyama', abbreviation: 'Toyama' },
  { name: 'Wakayama', abbreviation: 'Wakayama' },
  { name: 'Yamagata', abbreviation: 'Yamagata' },
  { name: 'Yamaguchi', abbreviation: 'Yamaguchi' },
  { name: 'Yamanashi', abbreviation: 'Yamanashi' },
]

export const AU_STATES: State[] = [
  { name: 'Australian Capital Territory', abbreviation: 'ACT' },
  { name: 'New South Wales', abbreviation: 'NSW' },
  { name: 'Northern Territory', abbreviation: 'NT' },
  { name: 'Queensland', abbreviation: 'QLD' },
  { name: 'South Australia', abbreviation: 'SA' },
  { name: 'Tasmania', abbreviation: 'TAS' },
  { name: 'Victoria', abbreviation: 'VIC' },
  { name: 'Western Australia', abbreviation: 'WA' },
]

export const BR_STATES: State[] = [
  { name: 'Acre', abbreviation: 'AC' },
  { name: 'Alagoas', abbreviation: 'AL' },
  { name: 'Amazonas', abbreviation: 'AM' },
  { name: 'Amapá', abbreviation: 'AP' },
  { name: 'Bahia', abbreviation: 'BA' },
  { name: 'Ceará', abbreviation: 'CE' },
  { name: 'Distrito Federal', abbreviation: 'DF' },
  { name: 'Espírito Santo', abbreviation: 'ES' },
  { name: 'Goiás', abbreviation: 'GO' },
  { name: 'Maranhão', abbreviation: 'MA' },
  { name: 'Minas Gerais', abbreviation: 'MG' },
  { name: 'Mato Grosso do Sul', abbreviation: 'MS' },
  { name: 'Mato Grosso', abbreviation: 'MT' },
  { name: 'Pará', abbreviation: 'PA' },
  { name: 'Paraíba', abbreviation: 'PB' },
  { name: 'Pernambuco', abbreviation: 'PE' },
  { name: 'Piauí', abbreviation: 'PI' },
  { name: 'Paraná', abbreviation: 'PR' },
  { name: 'Rio de Janeiro', abbreviation: 'RJ' },
  { name: 'Rio Grande do Norte', abbreviation: 'RN' },
  { name: 'Rondônia', abbreviation: 'RO' },
  { name: 'Roraima', abbreviation: 'RR' },
  { name: 'Rio Grande do Sul', abbreviation: 'RS' },
  { name: 'Santa Catarina', abbreviation: 'SC' },
  { name: 'Sergipe', abbreviation: 'SE' },
  { name: 'São Paulo', abbreviation: 'SP' },
  { name: 'Tocantins', abbreviation: 'TO' },
]
